import React from "react";
import ScaledLogo from "./ScaledLogo";
import styles from "./materials.module.scss";

const SignEventTitle = ({ event, textColor, bgColor }) => (
  <div className={styles.sign} style={{ "--mat-bg": bgColor, "--mat-text": textColor }}>
    <div className={styles.signLogoGroup}>
      <ScaledLogo color={event.color} width={499} height={575} />
      <span className={styles.signLogoText}>IxDA Stavanger</span>
    </div>
    <span className={styles.signEventName}>{event.eventName}</span>

  </div>
);

export default SignEventTitle;
